import { LanguageDetail, IDataArray } from "./../index";

export class Language implements IDataArray {
  Id: number;
  Part: string;
  Value: string;
  AttributeId: number;
  Offset: number;
  Created: Date;
  Modified: Date;
  ModifiedBy: string;

  public Detail: LanguageDetail = new LanguageDetail();

  public GetById(): number {
    return this.Id;
  }
}
